module.exports = __webpack_public_path__ + "static/media/pig.1694826f.png";